module.exports = __webpack_public_path__ + "static/media/g1.25b85cba.png";